
export class Groups {
  public id: number;
  public groupid: string;
  public description: string;
  public bodyid: string;
  public tag: string;

  constructor(
    id: number,
    groupid: string,
    description: string,
    bodyid: string,
    tag: string
  ) {
    this.id = id;
    this.groupid = groupid;
    this.description = description;
    this.bodyid = bodyid;
    this.tag = tag;
  }

}
